import styles from './FooterSocialLinks.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import type { ExternalLink } from 'api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';

interface IFooterSocialLinksProps {
  items?: Array<FlatEntry<ExternalLink>>;
  className?: string;
}

export const FooterSocialLinks: FC<IFooterSocialLinksProps> = ({ items = [], className }) => {
  if (!items?.length) return null;

  return (
    <div className={cx(styles.footerSocialLinks, className)}>
      {items.map((item, index) => (
        <ButtonLinkV2 key={componentKeyV2(item, index)} entry={item} />
      ))}
    </div>
  );
};

FooterSocialLinks.displayName = 'FooterSocialLinks';
